import type { DashBilling, DashBillingMonth } from "./types";

const ROLE: Record<DashBillingMonth["key"], string> = {
  prev: "Mois précédent",
  current: "Mois en cours",
  next: "Mois prochain",
};

type BillingOutlookProps = {
  billing?: DashBilling;
};

export function BillingOutlook({ billing }: BillingOutlookProps) {
  if (!billing || billing.months.length === 0) return null;
  return (
    <section className="fx-bill" aria-label="Facturation des trois mois">
      <div className="fx-panel__head">
        <h2>Facturation</h2>
        <span className="fx-mail__hint">TTC · le HT est indiqué en dessous</span>
      </div>
      <div className="fx-bill__months">
        {billing.months.map((month) => (
          <article className={`fx-bill__month${month.key === "next" ? " is-next" : ""}`} key={month.key}>
            <p className="fx-bill__role">{ROLE[month.key] ?? month.label}</p>
            <p className="fx-bill__name">{month.label}</p>
            <p className="fx-bill__amount">{month.amount}</p>
            <p className="fx-bill__meta">{month.detail}</p>
          </article>
        ))}
      </div>
      {billing.days.length > 0 ? (
        <div className="fx-bill__schedule">
          <h3>{billing.upcoming_title}</h3>
          <div className="fx-bill__lines">
            {billing.days.map((row) => (
              <div className="fx-bill__line" key={row.day}>
                <span className="fx-bill__when">{row.label}</span>
                <span className="fx-bill__count">{row.count_label}</span>
                <span className="fx-bill__sum">
                  {row.amount}
                  <small>{row.detail}</small>
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </section>
  );
}
